import { render, staticRenderFns } from "./ActivityEditForm.vue?vue&type=template&id=57a5b094"
import script from "./ActivityEditForm.vue?vue&type=script&lang=js"
export * from "./ActivityEditForm.vue?vue&type=script&lang=js"
import style0 from "./ActivityEditForm.vue?vue&type=style&index=0&id=57a5b094&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports